import { useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { redirect, actionToPath } from 'redux-first-router';
import { useTracking } from 'react-tracking';
import DocumentHeader from '@/components/DocumentHeader';
import SkyscraperBackground from '@/components/SkyscraperBackground';
import Break from '@/components/Break';
import {
  AuthenticationSelect,
  Method,
} from '@/components/AuthenticationSelect';
import {
  ROUTE_WELCOME,
  ROUTE_USER_REGISTER,
  ROUTE_PORTFOLIO_NEW,
} from '@/constants/routes';
import { useMount } from '@simplywallst/ui-core';

import { WelcomeWrapper, Heading } from './styled';
import { clearAllCookies } from '@/utilities/cookies';
import { useFlag } from '@/features/unleash';
import routesGenerator from '@/router/routesGenerator';

export const WelcomePage = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    page: 'Welcome',
    subject: 'page',
  });

  const queryClient = useQueryClient();
  useMount(() => {
    trackEvent({
      action: 'landed',
    });
    queryClient.clear();
    clearAllCookies();
  });

  const type = useSelector<{ location: { type: string } }, Method>((state) => {
    switch (state.location.type) {
      case ROUTE_USER_REGISTER:
        return 'register';
      case ROUTE_WELCOME:
      default:
        return 'login';
    }
  }, shallowEqual);
  const dispatch = useDispatch();

  const flag = useFlag({
    name: 'mono-redirect-to-new-portfolio',
  });
  const routesMap = routesGenerator();
  const newPortfolioUrl = actionToPath(
    { type: ROUTE_PORTFOLIO_NEW, payload: {} },
    routesMap
  );
  const postVerifyRedirectTo =
    flag.variant.name === 'variant' ? newPortfolioUrl : undefined;

  return (
    <Track>
      <SkyscraperBackground>
        <DocumentHeader title={'Welcome to Simply Wall St'} titleSuffix="" />
        <WelcomeWrapper>
          <Heading>
            Continue to Simply Wall St stock
            <Break smUp /> analysis tool
          </Heading>
          <AuthenticationSelect
            onChangeType={(type) => {
              if (type === 'login') {
                dispatch(redirect({ type: ROUTE_WELCOME }));
              }
              if (type === 'register') {
                dispatch(redirect({ type: ROUTE_USER_REGISTER }));
              }
            }}
            current={type}
            onRegisterSuccess={() => {
              trackEvent({
                modifier: 'registration',
                action: 'success',
              });
            }}
            postVerifyRedirectTo={postVerifyRedirectTo}
          />
        </WelcomeWrapper>
      </SkyscraperBackground>
    </Track>
  );
};
